class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener("DOMContentLoaded", function() {
  const cartItems = document.querySelectorAll('.mini-cart-item');

  cartItems.forEach(item => {
    const quantityInput = item.querySelector('.quantity__input');
    const minQty = parseInt(quantityInput.getAttribute('data-min'), 10);
    const maxQty = parseInt(quantityInput.getAttribute('data-max'), 10);
    const qtyIncrements = parseInt(quantityInput.getAttribute('step'), 10);
    const currentQty = parseInt(quantityInput.value, 10);
    const productName = item.querySelector('.mini-cart-item__name').textContent.trim();

    let isInvalidQty = false;

    if (minQty && currentQty < minQty) {
      isInvalidQty = true;
    }

    if (maxQty && currentQty > maxQty) {
      isInvalidQty = true;
    }

    if (qtyIncrements && currentQty % qtyIncrements !== 0) {
      isInvalidQty = true;
    }

    if (isInvalidQty) {
      removeItemFromCart(item, productName);
    }
  });
});

function removeItemFromCart(item, productName) {
  const variantId = item.querySelector('cart-drawer .quantity__input').getAttribute('data-quantity-variant-id');

  fetch(`/cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 0
    })
  })
      .then(response => response.json())
      .then(data => {
        item.remove();

        alert(`The product "${productName}" has been removed from the cart because its quantity does not meet the new requirements.`);

        location.reload();
      })
      .catch(error => console.error('Error removing product from cart:', error));
}

document.addEventListener('click', function(event) {
  if (event.target.matches('cart-drawer .quantity__button[name="minus"]')) {
    const quantityInput = event.target.closest('cart-drawer .quantity-popover-container').querySelector('.quantity__input');
    const minValue = parseInt(quantityInput.getAttribute('data-min'), 10);
    const cartQuantity = parseInt(quantityInput.getAttribute('data-cart-quantity'), 10);

    if (cartQuantity === minValue) {
      quantityInput.value = 0;
      quantityInput.dispatchEvent(new Event('change'));
    }
  }
});